import { Breakpoint, Button, Color, FormButton } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { CategoriesProps } from './matchToCategory.types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Color.Gray100};
  padding: 40px 16px;
  gap: 24px;

  @media ${Breakpoint.Tablet} {
    padding: 40px 24px;
  }
`;

export const Categories = styled.div<CategoriesProps>`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(266px, 1fr));
  gap: 20px;
  background-color: ${Color.Gray200};
  padding: 12px;
  min-height: ${({ $isSingleChoice }: CategoriesProps): number => !$isSingleChoice ? 496 : 302}px;
`;

export const StyledFormButton = styled(FormButton)`
  width: 90px;
  align-self: flex-end;
`;

export const TryAgainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    gap: 40px;
    padding-top: 40px;
  }
`;

export const StyledButton = styled(Button)`
  align-self: baseline;
`;

export const ResultImageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding-bottom: 0;
  }
`;

export const ResultImage = styled.img`
  width: 100%;

  @media ${Breakpoint.SmallDesktop} {
    width: auto;
  }
`;

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const ResultContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
`;
